import React from 'react';
import { Grid } from '@mui/material';
import { CustomTypography } from '../../shared/custom-typography/CustomTypography';

interface IProps {
  align?: string;
  borderLeft?: string;
  borderRight?: string;
  title: string;
  xs?: number;
}
export const TableHeader: React.FC<IProps> = (props) => {
  const { xs = 1.8, borderLeft = 'none', borderRight = 'none' } = props;

  return (
    <Grid
      item={true}
      xs={xs}
      borderLeft={borderLeft}
      borderRight={borderRight}
      height={'100%'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <CustomTypography
        fontWeight={'bold'}
        fontSize={'1rem'}
        textAlign={'right'}
      >
        {props.title}
      </CustomTypography>
    </Grid>
  );
};

TableHeader.displayName = 'TableHeader';
